if (!customElements.get('holiday-sale-banner')) {
  customElements.define(
    'holiday-sale-banner',
    class HolidaySaleBanner extends HTMLElement {
      connectedCallback() {
        this.nameElement = this.querySelector('[data-holiday-name]');
        this.countdownElement = this.querySelector('[data-holiday-countdown]');
        this.hoursElement = this.querySelector('[data-countdown-hours]');
        this.minutesElement = this.querySelector('[data-countdown-minutes]');
        this.secondsElement = this.querySelector('[data-countdown-seconds]');
        this.duration = Number(this.dataset.durationHours || 2) * 60 * 60 * 1000;
        this.setHoliday();
        this.endTime = this.readEndTime();
        this.updateCountdown();
        this.timer = window.setInterval(() => this.updateCountdown(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      setHoliday() {
        this.holiday = this.nextHoliday();
        this.storageKey = `lymphiva-holiday-sale-countdown-end-${this.holiday.date.getFullYear()}-${this.holiday.date.getMonth()}-${this.holiday.date.getDate()}`;
        if (this.nameElement) this.nameElement.textContent = this.holiday.name;
      }

      readEndTime() {
        const savedEnd = Number(window.localStorage.getItem(this.storageKey));
        if (Number.isFinite(savedEnd) && savedEnd > Date.now()) return savedEnd;
        return this.resetEndTime();
      }

      resetEndTime() {
        const endTime = Date.now() + this.duration;
        window.localStorage.setItem(this.storageKey, String(endTime));
        return endTime;
      }

      updateCountdown() {
        if (!this.countdownElement) return;
        let remaining = this.endTime - Date.now();

        if (remaining <= 0) {
          this.endTime = this.resetEndTime();
          remaining = this.duration;
        }

        const totalSeconds = Math.max(0, Math.floor(remaining / 1000));
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        if (this.hoursElement) this.hoursElement.textContent = String(hours).padStart(2, '0');
        if (this.minutesElement) this.minutesElement.textContent = String(minutes).padStart(2, '0');
        if (this.secondsElement) this.secondsElement.textContent = String(seconds).padStart(2, '0');
        this.countdownElement.dateTime = `PT${hours}H${minutes}M${seconds}S`;
        this.countdownElement.setAttribute('aria-label', `${hours} hours, ${minutes} minutes, ${seconds} seconds remaining in the ${this.holiday.name} sale`);
      }

      nextHoliday() {
        const now = new Date();
        const holidays = [...this.holidaysForYear(now.getFullYear()), ...this.holidaysForYear(now.getFullYear() + 1)]
          .map((holiday) => ({ ...holiday, endTime: new Date(holiday.date.getFullYear(), holiday.date.getMonth(), holiday.date.getDate() + 1).getTime() }))
          .filter((holiday) => holiday.endTime > now.getTime())
          .sort((a, b) => a.date - b.date);

        return holidays[0] || { name: 'Seasonal', date: now };
      }

      holidaysForYear(year) {
        const fixed = (month, day, name) => ({ date: new Date(year, month - 1, day), name });
        const nth = (month, weekday, occurrence, name) => ({
          date: this.nthWeekday(year, month - 1, weekday, occurrence),
          name,
        });
        const last = (month, weekday, name) => ({ date: this.lastWeekday(year, month - 1, weekday), name });
        const easter = this.easterDate(year);
        const thanksgiving = this.nthWeekday(year, 10, 4, 4);

        return [
          fixed(1, 1, "New Year's"),
          nth(1, 1, 3, 'Martin Luther King Jr. Day'),
          fixed(2, 2, 'Groundhog Day'),
          fixed(2, 14, "Valentine's Day"),
          nth(2, 1, 3, "Presidents' Day"),
          fixed(3, 8, "International Women's Day"),
          fixed(3, 17, "St. Patrick's Day"),
          { date: easter, name: 'Easter' },
          fixed(4, 22, 'Earth Day'),
          nth(5, 0, 2, "Mother's Day"),
          last(5, 1, 'Memorial Day'),
          fixed(6, 14, 'Flag Day'),
          nth(6, 0, 3, "Father's Day"),
          fixed(6, 19, 'Juneteenth'),
          fixed(7, 4, 'Independence Day'),
          fixed(8, 15, 'National Relaxation Day'),
          nth(9, 1, 1, 'Labor Day'),
          fixed(9, 29, 'National Coffee Day'),
          fixed(10, 10, 'World Mental Health Day'),
          fixed(10, 31, 'Halloween'),
          fixed(11, 11, 'Veterans Day'),
          { date: thanksgiving, name: 'Thanksgiving' },
          { date: new Date(year, 10, thanksgiving.getDate() + 1), name: 'Black Friday' },
          { date: new Date(year, 10, thanksgiving.getDate() + 2), name: 'Small Business Saturday' },
          { date: new Date(year, 10, thanksgiving.getDate() + 4), name: 'Cyber Monday' },
          fixed(12, 25, 'Christmas'),
        ];
      }

      nthWeekday(year, month, weekday, occurrence) {
        const date = new Date(year, month, 1);
        date.setDate(1 + ((7 + weekday - date.getDay()) % 7) + (occurrence - 1) * 7);
        return date;
      }

      lastWeekday(year, month, weekday) {
        const date = new Date(year, month + 1, 0);
        date.setDate(date.getDate() - ((7 + date.getDay() - weekday) % 7));
        return date;
      }

      easterDate(year) {
        const a = year % 19;
        const b = Math.floor(year / 100);
        const c = year % 100;
        const d = Math.floor(b / 4);
        const e = b % 4;
        const f = Math.floor((b + 8) / 25);
        const g = Math.floor((b - f + 1) / 3);
        const h = (19 * a + b - d - g + 15) % 30;
        const i = Math.floor(c / 4);
        const k = c % 4;
        const l = (32 + 2 * e + 2 * i - h - k) % 7;
        const m = Math.floor((a + 11 * h + 22 * l) / 451);
        const month = Math.floor((h + l - 7 * m + 114) / 31);
        const day = ((h + l - 7 * m + 114) % 31) + 1;
        return new Date(year, month - 1, day);
      }
    },
  );
}
